import type { ComponentPropsWithoutRef } from 'react'
import classNames from 'classnames'

import styles from './styles/Button.css'

export type ButtonColor = 'primary' | 'secondary' | 'text' | 'blank' | 'red' | 'blue' | 'white' | 'transparent'
export type ButtonSize = 'small' | 'medium' | 'large' | 'extraLarge'

// `color` is omitted from the inherited DOM props first: <button> has a (legacy,
// unused-here) color attribute typed as a free string, which would otherwise widen
// the union back out.
type ButtonProps = Omit<ComponentPropsWithoutRef<'button'>, 'color'> & {
  color?: ButtonColor
  size?: ButtonSize
  pill?: boolean
  group?: boolean
  row?: boolean
  bold?: boolean
  small?: boolean
  tiny?: boolean
  rounded?: boolean
  square?: boolean
  circle?: boolean
}

export function Button({
  className,
  children,
  color = 'transparent',
  pill,
  group,
  row,
  bold,
  small,
  tiny,
  rounded = false,
  size = 'medium',
  square = false,
  circle = false,
  ...rest
}: ButtonProps) {
  const noBorder = color === 'secondary' && (rounded || square || circle)

  const classes = classNames(className, styles.btn, styles[`btn--${color}`], styles[`size--${size}`], {
    [styles.pill]: pill,
    [styles.group]: group,
    [styles.row]: row,
    [styles.bold]: bold,
    [styles.small]: small,
    [styles.tiny]: tiny,
    [styles.rounded]: rounded,
    [styles.noBorder]: noBorder,
    [styles[`square--${size}`]]: square,
    [styles[`circle--${size}`]]: circle
  })

  return (
    <button className={classes} {...rest}>
      {children}
    </button>
  )
}

export default Button
